<template>
  <div id="heatmap" />
</template>

<script>
import moment from "moment";
import Highcharts from "highcharts/highcharts.js";
import Exporting from "highcharts/modules/heatmap";
Exporting(Highcharts);

export default {
  name: "heatmap_chart",
  props: {
    dataset: Object,
  },
  data() {
    return {
      data: this.dataset,
    };
  },
  methods: {
    loadChart: function (data) {
      let self = this;
      var config = {
        chart: {
          type: "heatmap",
          plotBorderWidth: 1,
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: data.x_label,
        },
        yAxis: {
          categories: data.y_label,
          title: null,
        },
        colorAxis: {
          min: 0,
          minColor: "#FFFFFF",
          maxColor: "#6358e2",
        },
        legend: {
          align: "right",
          layout: "vertical",
          verticalAlign: "top",
          symbolHeight: 200,
        },
        credits: { enabled: false },
        tooltip: {
          formatter: function () {
            return (
              "Terdapat <b>" +
              this.point.value +
              "</b> mention pada <br><b>" +
              this.series.yAxis.categories[this.point.y] +
              " " +
              this.series.xAxis.categories[this.point.x] +
              "</b>"
            );
          },
        },
        series: [
          {
            name: "Mentions per Hari",
            borderWidth: 1,
            data: data.value,
            dataLabels: {
              enabled: true,
              color: "#000000",
            },
            point: {
              events: {
                click: function (event) {
                  if (event.point.value > 0) {
                    const time = String(event.point.y).padStart(2, "0");
                    let params = self.$route.query;
                    if ("items" in params) {
                      delete params.items;
                    }
                    params.from =
                      moment(self.$route.query.from).format("YYYY-MM-DD") +
                      time +
                      ":00";
                    params.to =
                      moment(self.$route.query.to).format("YYYY-MM-DD") +
                      time +
                      ":59";
                    if (
                      params.from.substring(0, 10) == params.to.substring(0, 10)
                    ) {
                      if (params.day) {
                        delete params.day;
                      }
                    } else {
                      params.day = event.point.x + 1;
                    }
                    params.sources = btoa(
                      "facebook,twitter,instagram,linkedin,tiktok,youtube,forum,blog,review"
                    );
                    self.$router.push({ path: "/posts", query: params });
                  }
                },
              },
            },
          },
        ],
      };
      new Highcharts.chart("heatmap", config);
    },
  },
  mounted: function () {
    if (this.data != null) {
      this.loadChart(this.data);
    }
  },
};
</script>